import { render, staticRenderFns } from "./_channel.vue?vue&type=template&id=b68c342a&"
import script from "./_channel.vue?vue&type=script&lang=js&"
export * from "./_channel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SubmissionHero: require('/opt/render/project/src/channels2022/src/components/submission/SubmissionHero.vue').default,SubmissionCategories: require('/opt/render/project/src/channels2022/src/components/submission/SubmissionCategories.vue').default,HomeBenefits: require('/opt/render/project/src/channels2022/src/components/home-page/HomeBenefits.vue').default,SubmissionSteps: require('/opt/render/project/src/channels2022/src/components/submission/SubmissionSteps.vue').default,HomeFaqs: require('/opt/render/project/src/channels2022/src/components/home-page/HomeFaqs.vue').default})
